module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_materialParams.1001.jpg.22194411.webp";